import { FC } from 'react'
import { Edit } from 'react-admin'
import { HeaderTitle } from '../../components'
import { pageSx } from '../../components/ui'
import type { OrganizationRecord } from '../../types/apiTypes'
import OrganizationForm, { cleanApps } from './OrganizationForm'

const OrganizationsEdit: FC = () => (
  <Edit
    component="div"
    actions={false}
    sx={pageSx}
    redirect="show"
    title={<HeaderTitle i18n="resources.organization.edit" />}
    // Pessimistic: 409/503 from the API must be visible, not rolled back after an optimistic success.
    mutationMode="pessimistic"
    // organizationId is immutable and rejected by the API (extra=forbid).
    transform={(data: Partial<OrganizationRecord>) => ({
      name: data.name,
      apps: cleanApps(data.apps, true),
    })}
  >
    <OrganizationForm isEdit />
  </Edit>
)

export default OrganizationsEdit
